import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Trash2 } from "lucide-react";
import { api, assetUrl, formatApiErrorDetail } from "../../lib/api";
import { useSettings } from "../../context/SettingsContext";
import { ImageUploader } from "./shared";
import { STORE } from "../../data/store";
import { ChangePassword } from "./ChangePassword";

export const SettingsManager = () => {
  const { settings, setSettings } = useSettings();
  const [logo, setLogo] = useState(settings.logo_url || "");
  const [saving, setSaving] = useState(false);

  const save = async (value) => {
    setSaving(true);
    try {
      const s = await api.updateSettings({ ...settings, logo_url: value });
      setSettings(s); setLogo(s.logo_url);
      toast.success(value ? "Logotipo actualizado" : "Logotipo quitado");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setSaving(false); }
  };

  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-gray-900">Ajustes del sitio</h1>
      <p className="text-gray-500 text-sm mb-6">Logotipo del encabezado y seguridad de tu cuenta.</p>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <ImageUploader label="Logotipo (PNG transparente u horizontal)" value={logo} onChange={setLogo} />
          <div className="mt-5 flex flex-wrap gap-2">
            <button data-testid="settings-save-logo" disabled={saving || logo === (settings.logo_url || "")} onClick={() => save(logo)}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-[#0A3977] text-white font-bold disabled:opacity-50">
              {saving && <Loader2 className="w-4 h-4 animate-spin" />} Guardar logotipo
            </button>
            {settings.logo_url && (
              <button data-testid="settings-remove-logo" disabled={saving} onClick={() => save("")}
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg border border-gray-300 font-semibold text-[#E02424] hover:bg-red-50">
                <Trash2 className="w-4 h-4" /> Quitar logotipo
              </button>
            )}
          </div>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <div className="text-xs font-bold tracking-widest uppercase text-gray-500 mb-3">Vista previa del encabezado</div>
          <div data-testid="settings-logo-preview" className="h-16 px-4 flex items-center border border-gray-200 rounded-lg bg-white/95">
            <img src={logo ? assetUrl(logo) : "/logo.png"} alt={STORE.name} className="h-12 w-auto max-w-[220px] object-contain" />
          </div>
          <p className="mt-3 text-xs text-gray-400">Si no cargás un logotipo se usa el logo por defecto de Promax Tintas. Recomendado: 600×160 px aprox.</p>
        </div>
      </div>

      <div className="mt-6 grid lg:grid-cols-2 gap-6">
        <ChangePassword />
      </div>
    </div>
  );
};
